const localStorageNames = {
  queueProduct: 'postponedQueueProduct',
  queueProducts: 'postponedQueueProducts',
  queueLimitedProduct: 'postponedQueueLimitedProduct',
  queueLimitedProducts: 'postponedQueueLimitedProducts',
  cartProduct: 'postponedCartProduct',
  skincareIntroItems: 'skincareIntroItems',
  makeupLandingItems: 'makeupLandingItems',
  makeupLandingNewStyleItems: 'makeupLandingNewStyleItems',
  collectionLandingPageItems: 'customCollectionsPageItems',
  pickYourScentFlowItems: 'pickYourScentFlowItems',
  stockNotificationSubscriptionProductId: 'stockNotificationSubscriptionPostponedProductId',
}


export default localStorageNames
